export default {
    namespaced: true,
    state: {
        errorData: [],
        currentSiteId: null,
        indexingHistory: {},
        indexingTotal: null,
        from: null,
        to: null,
        currentPage: 1,
        totalRows: null,
        perPage: 10,
        sortField: 'datetime',
        sortDir: 'desc',
        indexingStatus: null,
        isGoogleKeyUploaded: false,
        domain: false,
        updatePeriod: 180,
    },
    getters: {
        SORT_FIELD: state => {
            return state.sortField;
        },
        SORT_DIR: state => {
            return state.sortDir;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows / state.perPage);
        },
        INDEXING_HISTORY: state => {
            return state.indexingHistory;
        },
        CURRENT_SITE_ID: state => {
            return state.currentSiteId;
        },
        ERROR_DATA: state => {
            return state.errorData;
        },
        FROM: state => {
            return state.from;
        },
        TO: state => {
            return state.to;
        },
        INDEXING_TOTAL: state => {
            return state.indexingTotal;
        },
        INDEXING_STATUS: state => {
            return state.indexingStatus;
        },
        IS_GOOGLE_KEY_UPLOADED: state => {
            return state.isGoogleKeyUploaded;
        },
        DOMAIN: state => {
            return state.domain;
        },
        UPDATE_PERIOD: state => {
            return state.updatePeriod;
        },
    },
    mutations: {
        DOMAIN: (state, payload) => {
            return state.domain = payload;
        },
        SORT_FIELD: (state, payload) => {
            return state.sortField = payload;
        },
        SORT_DIR: (state, payload) => {
            return state.sortDir = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
        INDEXING_HISTORY: (state, payload) => {
            return state.indexingHistory = payload;
        },
        CURRENT_SITE_ID: (state, payload) => {
            return state.currentSiteId = payload;
        },
        ERROR_DATA: (state, payload) => {
            return state.errorData = payload;
        },
        FROM: (state, payload) => {
            return state.from = payload;
        },
        TO: (state, payload) => {
            return state.to = payload;
        },
        INDEXING_TOTAL: (state, payload) => {
            return state.indexingTotal = payload;
        },
        INDEXING_STATUS: (state, payload) => {
            return state.indexingStatus = payload;
        },
        IS_GOOGLE_KEY_UPLOADED: (state, payload) => {
            return state.isGoogleKeyUploaded = payload;
        },
        UPDATE_PERIOD: (state, payload) => {
            return state.updatePeriod = payload;
        },
    },
    actions: {
        GET_ERROR: async ({state}, payload) => {
            payload.th.showOverlay++;
            let offset = state.perPage * (state.currentPage - 1)
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-indexing-error/' + state.currentSiteId + '?sort=' + state.sortField + '&dir=' + state.sortDir
                    + '&limit=' + state.perPage + '&offset=' + offset,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.errorData = responseData.data
                    state.totalRows = responseData.count
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        GET_HISTORY: async ({state}, payload) => {
            payload.th.showOverlay++;
            state.indexingHistory = {};
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-indexing-statistic/' + state.currentSiteId
                    + '?from=' + state.from + '&to=' + state.to,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let error = responseData.error
                    let indexing = responseData.indexing
                    state.indexingTotal = responseData.total

                    state.indexingHistory = {
                        labels: [],
                        datasets: [
                            {
                                label: 'Проиндексировано',
                                borderColor: '#FF8C00',
                                data: [],
                                fill: false,
                            },
                            {
                                label: 'Ошибки',
                                borderColor: '#0000FF',
                                data: [],
                                fill: false,
                            },
                        ]
                    }
                    // set indexing data
                    for (let key in indexing) {
                        let val = indexing[key]
                        state.indexingHistory.labels.push(val.formatDate);
                        state.indexingHistory.datasets[0].data.push(val.count);
                    }
                    // set error data
                    for (let key in error) {
                        let val = error[key]
                        state.indexingHistory.datasets[1].data.push(val.count);
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay--
                },
            });
        },
        UPLOAD_FILE: async ({state}, payload) => {
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/sites/google-key/' + state.currentSiteId,
                parameter: payload.formData,
                th: payload.th,
                config: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                    state.isGoogleKeyUploaded = true
                },
                getResponse: () => {
                    payload.th.isLoad = false;
                }
            });
        },
        SWITCH_STATUS: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/sites/switch-indexing-status/' + state.currentSiteId,
                parameter: {
                    indexingStatus: state.indexingStatus
                },
                th: payload.th,
                showSuccessMessage: false,
                getResponse: () => {
                    payload.th.showOverlay--;
                },
                getHandleError: () => {
                    payload.th.indexingStatus = !payload.th.indexingStatus
                }
            });
        },
        FILE_DELETE: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/sites/delete-google-file/' + state.currentSiteId,
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: () => {
                    state.isGoogleKeyUploaded = false
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        GET_INDEXING_STATUS: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-indexing-status/' + state.currentSiteId,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    payload.th.indexingStatus = responseData.data.indexingStatus
                    state.indexingStatus = responseData.data.indexingStatus

                    state.updatePeriod = responseData.data.updatePeriod
                    payload.th.updatePeriod = responseData.data.updatePeriod

                    state.isGoogleKeyUploaded = responseData.data.isGoogleKeyUploaded
                    state.domain = responseData.data.domain
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        CHANGE_UPDATE_PERIOD: async ({state}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/sites/update-indexing-period/' + state.currentSiteId,
                parameter: {
                    updatePeriod: state.updatePeriod
                },
                th: payload.th,
                showSuccessMessage: false,
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
    }
}